export function getKeyById(obj, id) {
  return Object.keys(obj).find((key) => obj[key].id === id) || null;
}

export function getEntryById(obj, id) {
  return Object.values(obj).find((entry) => entry.id === id) || null;
}

export function getLabelById(obj, id) {
  const entry = getEntryById(obj, id);
  return entry ? entry.label : null;
}
